import { createEnvelopeSource } from './create-envelope-source';

/**
 * Pins `ageRestricted: 'true'` on the same endpoint `coupon-redeemed` reads,
 * narrowing the `category` axis server-side to age-restricted categories.
 * Only `bars`/`pie`, the two forms By count and By share read.
 */
export const couponRedeemedAgeRestrictedSource = createEnvelopeSource({
    label: 'Age-restricted coupons redeemed',
    endpoint: 'analytics/coupons/redeemed',
    metrics: [
        { id: 'couponsRedeemed', label: 'Coupons redeemed', type: 'scalar' },
    ],
    forms: ['bars', 'pie'],
    regionGrain: 'province',
    staticParams: { ageRestricted: 'true' },
});
